import { TickIcon } from '@/Assets/Icons/Tick';
import { Image } from '@/components/Image';
import { TaskItem } from '@/layouts/QuestsLayout/components/TaskItem';
import clsx from 'clsx';
import { useShallow } from 'zustand/react/shallow';
import { useQuestsAdventuresStore } from '../../store';
import { AdventuresTabs } from '../../types';
import { Adventure, Journey } from '@/types/phases';
import './styles.css';
import { PHASES_API_URL } from '@/Config/ApiConfig';
import { mainnetNetworks } from '@/constants/mock_networks.constants';

interface QuestsItemProps {
  adventure: Journey | Adventure;
  variant: AdventuresTabs;
}

export function QuestsItem({ adventure, variant }: QuestsItemProps) {
  const [tasks] = useQuestsAdventuresStore(
    useShallow(s => [s.tasks[adventure.id]])
  );
  const uncompletedTasks = tasks?.filter(task => !task.isCompleted);
  const hasUncompletedTasks =
    tasks?.length === 0 || (uncompletedTasks?.length ?? 0) > 0;

  if (variant === AdventuresTabs.ActiveAdventures && !hasUncompletedTasks)
    return null;

  const description = adventure.description
    ? adventure.description.split('image')
    : '';

  const capsuleImg = mainnetNetworks.find(
    n => n.name === adventure.network
  )?.capsuleWithBg;

  return (
    <div
      className={clsx(
        'quests-adventures--item',
        adventure.network?.toLowerCase().replace(/\s+/g, '')
      )}
    >
      <div className="d-flex align-items-center">
        <div>
          <h2 className="quests-adventures--item-heading">
            {adventure.journey}
          </h2>

          <div
            className={clsx('quests-badge', !hasUncompletedTasks && 'active')}
          >
            {!hasUncompletedTasks && <TickIcon color="#B2FFAB" />} x0.25
            Multiplier
          </div>
        </div>
        <div className="quests-adventures--item-wrapper">
          <Image
            withSmoothLoading
            src={capsuleImg}
            alt={adventure.journey}
            draggable={false}
            className="quests-adventures--item-image"
          />
        </div>
      </div>
      <div className="quests-adventures--item-description">
        {description[0]}
        <Image
          withSmoothLoading
          src={PHASES_API_URL + adventure.icon}
          width={16}
          height={16}
        />
        {description[1]}
      </div>
      <div className="quests-tasks">
        {tasks?.map((task, i) => (
          <TaskItem
            key={task?.id || i}
            task={task}
            journeyId={adventure.id}
            variant="adventure"
          />
        ))}
      </div>
    </div>
  );
}
